import * as _ from 'lodash';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dataRegExpFilter'
})

export class DataRegExpFilterPipe implements PipeTransform {

    transform(rows: any[], query: string): any {
        if (query) {
            if (_.isArray(rows)) {
                const regexp = new RegExp('.*' + query + '.*', 'img');
                rows = rows.filter(row => {
                    for (const key in row) {
                        if (row.hasOwnProperty(key)) {
                            const value = row[key];
                            if (regexp.test(value)) {
                                return true;
                            }
                        }
                    }
                });
                console.log('rows', rows);
            } else {
                throw new Error('DataRegExpFilterPipe: 参数不是数组');
            }
        }
        return rows;
    }
}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/element/data-regexp-filter.pipe.ts